import { motion } from 'framer-motion';
import logo from '@/assets/logo.png';

/** Full-viewport loading screen — app bootstrap, route-level suspense fallback. */
export function LoadingScreen({ label = 'Loading ProjectPilot AI…' }: { label?: string }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-gray-50 dark:bg-gray-950">
      <motion.div
        className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-2xl bg-white shadow-soft ring-1 ring-black/5"
        animate={{ scale: [1, 1.08, 1] }}
        transition={{ duration: 1.4, repeat: Infinity, ease: 'easeInOut' }}
      >
        <img src={logo} alt="ProjectPilot" className="h-full w-full object-cover object-left" />
      </motion.div>
      <p className="text-sm text-gray-500 dark:text-gray-400">{label}</p>
    </div>
  );
}
